module.exports = __webpack_public_path__ + "img/img-home2@3x.394d5489.png";